// extracted by mini-css-extract-plugin
module.exports = {"bg":"index-bg--Zrbe","registerModalRoot":"index-registerModalRoot-1DiWD","registerIframe":"index-registerIframe-2D9Zb","closeBtn":"index-closeBtn-1-e2F"};